// ============================================================================
// 📁 FILE: src/modules/ticket/components/detail/SlaBlock.jsx
// 📝 PURPOSE:
//    Displays SLA info: status + countdown timers + escalation levels.
// ============================================================================

import React from "react";
import formatSeconds from "./CountdownRenderer";

// Basic color decisions
function getStatusBadge(status) {
  const s = (status || "").toUpperCase();
  if (s === "ACTIVE") return <span className="badge bg-success">Active</span>;
  if (s === "PAUSED") return <span className="badge bg-warning text-dark">Paused</span>;
  if (s === "BREACHED") return <span className="badge bg-danger">Breached</span>;
  if (s === "MET") return <span className="badge bg-secondary">Met</span>;
  return <span className="badge bg-light text-dark">{status || "-"}</span>;
}

export default function SlaBlock({ sla, loading }) {
  if (loading) {
    return (
      <div className="card shadow-sm mb-3" style={{ borderRadius: 18 }}>
        <div className="card-body small text-muted">Loading SLA...</div>
      </div>
    );
  }

  if (!sla) {
    return (
      <div className="card shadow-sm mb-3" style={{ borderRadius: 18 }}>
        <div className="card-body small text-muted">No SLA Applied</div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm mb-3" style={{ borderRadius: 18 }}>
      <div className="card-body">
        {/* STATUS */}
        <div className="d-flex justify-content-between mb-2">
          <strong>SLA Status</strong>
          {getStatusBadge(sla.sla_status)}
        </div>

        {/* RESPONSE SLA */}
        {sla.response && (
          <div className="mb-2">
            <div className="small text-muted">Response Due</div>
            <div className="fw-semibold">
              {formatSeconds(sla.response.remaining_seconds)}
            </div>
          </div>
        )}

        {/* RESOLUTION SLA */}
        {sla.resolution && (
          <div className="mb-2">
            <div className="small text-muted">Resolution Due</div>
            <div className="fw-semibold">
              {formatSeconds(sla.resolution.remaining_seconds)}
            </div>
          </div>
        )}

        {/* ESCALATION LEVEL */}
        <div>
          <div className="small text-muted">Escalation Level</div>
          <div className="fw-semibold">{sla.escalation_level ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
